import { ITagAssociationType } from "../../common/models/ITagAssociationType";

export enum DefaultTagAssociationTypeEnum {
    Graph = 1,
    Mapping = 2
}

export interface IObjectDefaultsModel {
    tagAssociationTypes: ITagAssociationType[];
    defaults: IObjectTagAssociationTypeDefaultModel[];
    canModifyDevice: boolean;
}

export interface IObjectTagAssociationTypeDefaultModel {
    tagAssociationTypeID: number;
    defaultType: DefaultTagAssociationTypeEnum;
}

export interface ISaveObjectDefaultsModel {
    defaults: Array<IObjectTagAssociationTypeDefaultModel>
}
